import {createStore} from 'vuex';
import auth from './modules/auth';
import courses from './modules/courses';
import sidebar from './modules/sidebar';
import event from './modules/event';
import categories from './modules/categories';
import lesson from './modules/lesson'
import breadcrumbs from "./modules/breadcrumbs";
import enroll from "./modules/enroll";
import activities from "./modules/activities";
import calendar from './modules/calendar'
import grades from "@/store/modules/grades";
import files from "@/store/modules/files";
import quiz from "@/store/modules/quiz";
import users from "@/store/modules/users";
import glossary from "@/store/modules/glossary";
import feedback from "@/store/modules/feedback";
import assign from "@/store/modules/assign";
import sale from "./modules/sale";
import url from "@/store/modules/url";
import books from "@/store/modules/book"
import page from "@/store/modules/page"
import forum from "@/store/modules/forum"
import comments from "@/store/modules/comments";
import cert from "@/store/modules/certs"
import folder from '@/store/modules/folder'
import wiki from '@/store/modules/wiki'
import badges from '@/store/modules/badges'
import essay from '@/store/modules/essay';
import questionnaire from "@/store/modules/questionnaire";
import questions from "@/store/modules/questions";
import examus2 from "@/store/modules/examus2";
import profi from "@/store/modules/profi";
import openUtmn from "@/store/modules/openUtmn";
import errors from "@/store/modules/errors";
import info from "@/store/modules/info";
import scorm from "@/store/modules/scorm";
import yandex from "@/store/modules/yandex";
import aidocsanner from "@/store/modules/aidocscanner"

// const params = new URLSearchParams(document.location.href.split('?').pop())
// const query = {}
// params.forEach((val, key) => {
//     query[key] = val
// })

export default createStore({
    state: {
        searchOverflow: false,
        urlToNavigate: null,
        isHeaderVisible: true,
        version: '0.0.1',
        // queryStringParams: query
    },
    mutations: {
        saveSearchOverflow(state, payload) {
            state.searchOverflow = payload
        },
        setUrlToNavAfterLogin(state, payload) {
            state.urlToNavigate = payload
        },
        setHeaderVisibility(state, payload) {
            state.isHeaderVisible = payload
        }
    },
    actions: {
        setSearchHiddenOverflow({commit}, payload) {
            commit('saveSearchOverflow', payload)
        },
    },
    getters: {
        version: state => state.version,
        searchOverflow: state => state.searchOverflow,
        urlToNavigate: state => state.urlToNavigate,
        isHeaderVisible: state => state.isHeaderVisible
        // queryParams: state => name => (state.queryStringParams[name] || state.queryStringParams)
    },
    modules: {
        activities,
        assign,
        auth,
        badges,
        books,
        breadcrumbs,
        calendar,
        categories,
        cert,
        comments,
        courses,
        enroll,
        errors,
        essay,
        event,
        examus2,
        feedback,
        files,
        folder,
        forum,
        glossary,
        grades,
        info,
        lesson,
        openUtmn,
        page,
        profi,
        questionnaire,
        questions,
        quiz,
        sale,
        scorm,
        sidebar,
        url,
        users,
        wiki,
        yandex,
        aidocsanner
    }
})
